import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { AdminPanelSettings, ExitToApp } from '@mui/icons-material';

const ImpersonationBanner = ({ schoolName, onExit }) => (
  <Box
    sx={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 9999,
      bgcolor: '#e65100',
      color: '#fff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 2,
      px: 2,
      py: 0.75,
    }}
  >
    <AdminPanelSettings fontSize="small" />
    <Typography variant="body2" fontWeight={600}>
      Platform Admin — viewing as: <strong>{schoolName}</strong>
    </Typography>
    <Button
      size="small"
      variant="outlined"
      startIcon={<ExitToApp fontSize="small" />}
      onClick={onExit}
      sx={{
        color: '#fff',
        borderColor: 'rgba(255,255,255,0.6)',
        ml: 2,
        py: 0.25,
        fontSize: '0.75rem',
        '&:hover': { borderColor: '#fff', bgcolor: 'rgba(255,255,255,0.1)' },
      }}
    >
      Exit School
    </Button>
  </Box>
);

export default ImpersonationBanner;
